import { type CSSProperties } from "react";
import ButtonLink from "src/components/buttonlink/ButtonLink";
import PosterWithFloatingTrailerButton from "src/components/filmlistwithproviders/PosterWithFloatingTrailerButton";
import InlineFilmListBanner from "src/components/richtext/inlineFilmList/InlineFilmListBanner";
import type IFilmList from "src/lib/types/IFilmList";
import styles from "./InlineFilmList.module.css";

//#region [Props]
type InlineFilmListProps = {
    value: IFilmList;
};
//#endregion

//#region [Component]
export default function InlineFilmList({ value }: InlineFilmListProps) {
    return <aside className={styles.InlineFilmList} style={{ "--cfl-themecolor": value.filmList.themeColor?.hex ?? "#ffffff" } as CSSProperties}>
        <span className={styles.InlineFilmList_Title}>{value.filmList.title}</span>
        <InlineFilmListBanner filmList={value.filmList} />
        <div className={styles.PosterContainer}>
            {value.filmList.films.map(film => <PosterWithFloatingTrailerButton key={film._id} film={film} className={styles.Poster} hideKinoklubb />)}
        </div>
        {value.linkUrl && value.linkLabel && <div className={styles.ButtonContainer}>
            <ButtonLink href={value.linkUrl} className={styles.Button}>{value.linkLabel}</ButtonLink>
        </div>}
    </aside>;
}
//#endregion

//#region [Styles]

//#endregion